import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import SessionLayout from '../../layouts/SessionLayout'
import PlanSession123 from './PlanSession123'

export default class Plan extends Component {
  render() {
    const { match } = this.props
    const { session, patientID } = match.params

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          <SessionLayout title="titles.plan">
            <PlanSession123 session={session} />
          </SessionLayout>
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Plan/index.js